import React from 'react';
import { Tooltip } from '@mui/material';
import { ReactComponent as Info } from '../../../assets/info.svg';
import { Body } from '@vds/typography';
import { DEVICE_INFO_LABELS } from '../../constants/devices';
import './DeviceInfoTooltip.css';

const DeviceInfoTooltip = ({ serial, make, model, companionVersion, placement = "bottom" }) => {
  const tooltipContent = (
    <div className="device-info-tooltip-content">
      <div className="device-info-tooltip-field">
        <Body viewport="desktop" size="small" bold={true}>{DEVICE_INFO_LABELS.SERIAL_NUMBER}</Body>
        <div className="device-info-tooltip-value">
          <Body>{serial || "-"}</Body>
        </div>
      </div>
      <div className="device-info-tooltip-field">
        <Body viewport="desktop" size="small" bold={true}>{DEVICE_INFO_LABELS.MAKE}</Body>
        <div className="device-info-tooltip-value">
          <Body>{make || "-"}</Body>
        </div>
      </div>
      <div className="device-info-tooltip-field">
        <Body viewport="desktop" size="small" bold={true}>{DEVICE_INFO_LABELS.MODEL}</Body>
        <div className="device-info-tooltip-value">
          <Body>{model || "-"}</Body>
        </div>
      </div>
      <div className="device-info-tooltip-field">
        <Body viewport="desktop" size="small" bold={true}>{DEVICE_INFO_LABELS.COMPANION_VERSION}</Body>
        <div className="device-info-tooltip-value">
          <Body>{companionVersion || "-"}</Body>
        </div>
      </div>
    </div>
  );

  return (
    <Tooltip
      placement={placement}
      arrow
      title={tooltipContent}
      slotProps={{
        tooltip: {
          sx: {
            backgroundColor: "white",
            border: "1px solid black",
            "& .MuiTooltip-arrow": {
              backgroundColor: "white",
            },
          },
        },
      }}
    >
      <sup>
        <Info />
      </sup>
    </Tooltip>
  );
};

export default DeviceInfoTooltip;